import { useState, useEffect } from "react";
import { AppVariablesService } from "../../services/AppVariablesService";
import { useNavigate } from "react-router-dom";

export default function UpdateTerms() {
  const [termsOfUseUrl, setTermsOfUseUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const appVariablesService = new AppVariablesService();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await appVariablesService.find();
        if (response?.config?.termsOfUseUrl) {
          setTermsOfUseUrl(response.config.termsOfUseUrl);
        }
      } catch (err) {
        setError("Erro ao carregar os Termos de Uso.");
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  const handleSave = async () => {
    setSuccess(false);
    setError("");

    try {
      await appVariablesService.updateVariable({
        config: { termsOfUseUrl },
      });
      setSuccess(true);
    } catch (err) {
      setError("Erro ao salvar os Termos de Uso.");
    }
  };

  if (loading) {
    return <div className="text-center mt-5">Carregando Termos de Uso...</div>;
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Termos de Uso</h2>

      <div className="border rounded p-3">
        <textarea
          className="form-control"
          rows="15"
          value={termsOfUseUrl}
          onChange={(e) => setTermsOfUseUrl(e.target.value)}
        />
      </div>

      <div className="d-flex gap-3 mt-4 justify-content-end">
        {success && (
          <div className="text-success mt-3">
            Alterações Salvas com Sucesso!
          </div>
        )}
        {error && <div className="text-danger mt-3">{error}</div>}

        <button
          className="btn btn-danger"
          onClick={() => navigate("/admin/rules")}
        >
          Cancelar
        </button>
        <button className="btn btn-primary" onClick={handleSave}>
          Salvar
        </button>
      </div>
    </div>
  );
}
